import { Injectable } from '@angular/core';

const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

@Injectable({
  providedIn: 'root',
})
export class RazorpayLoaderService {
  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (typeof Razorpay !== 'undefined') {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(
        `script[src="${RAZORPAY_SCRIPT_URL}"]`,
      ) as HTMLScriptElement | null;

      if (existing) {
        if (typeof Razorpay !== 'undefined') {
          resolve();
          return;
        }

        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', () => {
          this.loadPromise = null;
          reject(new Error('Failed to load Razorpay checkout script'));
        });
        return;
      }

      const script = document.createElement('script');
      script.src = RAZORPAY_SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        this.loadPromise = null;
        reject(new Error('Failed to load Razorpay checkout script'));
      };
      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
